// extracted by mini-css-extract-plugin
module.exports = {"row":"_1RX39EQc7HTIMYeX_d0wOy"};